export const styles = () => ({
  pointer: {
    cursor: 'pointer',
  },
})

export default styles
